import { useRef, useEffect } from 'react';
import { noop } from 'lodash';
export function useOutsideClick(_ref) {
  var _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      _ref$onOutsideClick = _ref.onOutsideClick,
      onOutsideClick = _ref$onOutsideClick === void 0 ? noop : _ref$onOutsideClick;
  var buttonRef = useRef(null);
  var menuRef = useRef(null);
  useEffect(function () {
    function handleClick(e) {
      var _buttonRef$current, _menuRef$current;

      if (!((_buttonRef$current = buttonRef.current) !== null && _buttonRef$current !== void 0 && _buttonRef$current.contains(e.target)) && !((_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains(e.target))) {
        onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
      }
    }

    if (enabled) {
      window.document.addEventListener('click', handleClick, {
        capture: true
      });
      return function () {
        window.document.removeEventListener('click', handleClick, {
          capture: true
        });
      };
    }
  }, [enabled, onOutsideClick]);
  return {
    buttonRef: buttonRef,
    menuRef: menuRef
  };
}